module.exports = __webpack_public_path__ + "static/media/fly0111.0179246f.webp";